import { useEffect } from "react";

const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export const useDocumentTitleIfEq = (title: string, eq: string) => {
  useEffect(() => {
    if (document.title !== eq) {
      return;
    }
    document.title = title;
  }, [title, eq]);
};

export default useDocumentTitle;
